import MultiClassAudit from './src/main';

/* istanbul ignore next */
MultiClassAudit.install = function(Vue) {
  Vue.component(MultiClassAudit.name, MultiClassAudit);
};

export default MultiClassAudit;
